
import _compact from "lodash/compact"
import log from "plugins/loglevel/index"

interface EventParams {
  category: string
  action: string
  options?: {
    eventLabel?: string
    eventValue?: number
  }
}

declare global {
  interface Window {
    _hmt: undefined | {
      push: (el: any) => void,
    },
  }
}

const track = ({category, action, options = {}}: EventParams) => {
  const {eventLabel, eventValue} = options
  const debug_message_fragments = [
    "[App.Tracking.Baidu.Event.track]",
    "about to track event with:",
    [
      `category: [${category}]`,
      `action: [${action}]`,
      `options: [${JSON.stringify(options)}]`,
    ].join(" ,"),
  ]

  log.debug(debug_message_fragments.join(" "))

  if (typeof window._hmt !== "undefined") {
    // The format is _hmt.push(['_trackEvent', category, action, opt_label, opt_value])
    // It seems to be limited to an array, unlike Google Analytics.

    const data = _compact(["_trackEvent", category, action, eventLabel, eventValue])
    window._hmt.push(data)

  }
  else {
    log.debug("_hmt is missing")
  }
}

export default {track}
